// Dynamic import ensures Module Federation shared modules (React singleton)
// are initialized before the app boots.
import('./bootstrap');
